<template>
  <Layout>
    <section class="index-dashboard">

      <!-- START Top Area -->
      <div class="row justify-content-between search-business-area">
        <div class="col-xl-2 ct-mb-margin-bottom-100">
          <b-form-group label-class="col-form-label"
                        label="" label-for="searchBusiness"
                        label-cols="0" content-cols="12">
            <div class="row">
              <div class="col-2 d-flex justify-content-center align-items-center">
                <span class="mdi mdi-home-city-outline mdi-24px"></span>
              </div>
              <div class="col">
                <multiselect id="searchBusiness"
                             v-model="searchForm.busiId"
                             :options="businessOptions"
                             label="text" placeholder="" select-label=""
                             :allow-empty="false" deselect-label=""
                             :max-height="202">
                  <span slot="noResult">No Result</span>
                </multiselect>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-xl-3 d-flex justify-content-end align-items-center">
          <span class="font-size-16 fw-bold">{{ nowDate }}</span>
          <span class="ct-padding-left-75 mt-1">{{ nowTime }}</span>
          <span class="mdi mdi-refresh mdi-spin mdi-18px icon-padding-left ct-text-muted"
                style="cursor: pointer" @click="getItems()">
          </span>
        </div>
      </div>
      <!-- END Top Area -->

      <!-- START Middle Area -->
      <div class="row mt-3">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-body pb-0">
              <div class="row">

                <!-- START Middle Left Area -->
                <div class="col-xl-6">

                  <!-- // Station Info -->
                  <div class="row">
                    <div class="col">
                      <div class="card">
                        <div class="card-body">
                          <div class="row">

                            <div class="col-sm-5">
                              <div class="station-count-box">
                                <i class="mdi mdi-office-building-marker"/>
                                <div class="text-area">
                                  <span>
                                    충전소
                                  </span>
                                  <div>
                                  <span class="data-number">
                                    <count-to :startVal="0" :endVal="summaryCount.placeCount" :duration="1000"/>
                                  </span>
                                    <span>개소</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-sm-7">
                              <div class="charger-count-box">
                                <i class="mdi mdi-ev-station"/>
                                <div class="text-area row">
                                  <div class="col-6">
                                    <i class="mdi mdi-lightning-bolt-outline"></i>
                                    <span class="">완속 충전기</span>
                                    <div>
                                    <span class="data-number">
                                      <count-to :startVal="0" :endVal="summaryCount.slowCount" :duration="1000" />
                                    </span>
                                      <span>기</span>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <i class="mdi mdi-lightning-bolt"></i>
                                    <span>급속 충전기</span>
                                    <div>
                                    <span class="data-number">
                                      <count-to :startVal="0" :endVal="summaryCount.fastCount" :duration="1000" />
                                    </span>
                                      <span>기</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <hr class="mt-2" style="border-color: #999999" />

                          <div class="row mt-2">
                            <div class="col">
                              <div class="fw-bold">실시간 충전기 상태</div>
                              <div class="px-3" style="position: relative;">
                                <apexchart ref="dashboardEvesStatusChart" height="90" :options="statusChartOptions" :series="statusChartSeries" />
                                <div v-if="!statusChartSeries.filter(ele => ele.data[1] !== 0)[0]" class="text-secondary" style="position: absolute; left: 100px; top: 62px;">No Data</div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- // Evse Info -->
                  <div class="row">
                    <div class="col">
                      <div class="card">
                        <div class="card-body pb-0">
                          <h4 class="card-title mb-3">
                            <span class="icon-padding-right-50">
                            <i class="bx bx-spreadsheet fs-5 align-middle ct-card-title" />
                          </span>
                            <span class="ct-card-title">충전 이용 현황</span>
                          </h4>

                          <div class="row">
                            <div class="col-xl-3">
                              <div @click="useDetail('use')" style="cursor: pointer">
                                <info-count-to title="이용" value-title="건"
                                               :end-val="stationUseItems.chargedCount" :compared="stationUseItems.compChargedCount"
                                               icon-image="mdi-account-multiple-check" icon-color="success" class="shadow-sm" />
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div @click="useDetail('user')" style="cursor: pointer">
                                <info-count-to title="이용자" value-title="명"
                                               :end-val="stationUseItems.userCount" :compared="stationUseItems.compUserCount"
                                               icon-image="mdi-account-group" icon-color="info" class="shadow-sm" />
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div @click="useDetail('chargePower')" style="cursor: pointer">
                                <info-count-to title="충전량" value-title="kWh"
                                               :end-val="stationUseItems.totEnergy" :compared="stationUseItems.compTotEnergy"
                                               icon-image="mdi-battery-charging-high" icon-color="primary" class="shadow-sm" />
                              </div>
                            </div>
                            <div class="col-xl-3">
                              <div @click="useDetail('chargeCost')" style="cursor: pointer">
                                <info-count-to title="충전금액" value-title="원"
                                               :end-val="stationUseItems.totCost" :compared="stationUseItems.compTotCost"
                                               icon-image="mdi-cash-multiple" icon-color="danger" class="shadow-sm" />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- END Middle Left Area -->

                <!-- START Middle Right Area -->
                <div class="col-xl-6">

                  <!-- // Recommend Service -->
                  <div class="row">
                    <div class="col">
                      <div class="card">
                        <div class="card-body pb-0">
                          <h4 class="card-title mb-3">
                            <span class="icon-padding-right-50">
                              <i class="bx bx-car fs-5 align-middle ct-card-title" />
                            </span>
                            <span class="ct-card-title">맞춤형 충전 서비스</span>
                          </h4>

<!--                          <div class="row">
                            <div v-for="(items, i) in recommendService" class="col-xl-4">
                              <div class="card">
                                <div class="card-body">
                                  <div class="text-deep-green">
                                    {{ items.title }}
                                  </div>

                                  <div class="text-end">
                                    <div>
                                      <span class="fw-bold text-black" style="font-size: 22px">
                                        <countTo :startVal="0" :endVal="items.num1" :duration="1000" />
                                      </span>
                                      <span class="font-size-12 ct-text-muted">{{ i === 2 ? '회' : '명' }}</span>
                                    </div>

                                    <div>
                                      <span class="fw-bold text-danger" style="font-size: 22px">
                                        <countTo :startVal="0" :endVal="items.num2" :duration="1000" />
                                      </span>
                                      <span class="font-size-12 ct-text-muted">{{ i === 0 ? '건' : '원' }}</span>
                                    </div>

                                    <div>
                                      <span class="fw-bold text-primary" style="font-size: 22px">
                                        <countTo :startVal="0" :endVal="items.num3" :duration="1000" />
                                      </span>
                                      <span class="font-size-12 ct-text-muted">%</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>-->

                          <div class="row">
                            <div v-for="(items, i) in recommendService" :class="i<2 ? `col-xl-3`:`col-xl-6`">
                              <div class="card card-height-100">
                                <div class="card-body">
                                  <div class="text-deep-green text-center">
                                    {{ items.title }}
                                  </div>

                                  <div v-if="i !== 2" class="py-4 mt-2">
                                    <div class="text-center">
                                      <span class="fw-bold text-black" style="font-size: 22px">
                                        <countTo :startVal="0" :endVal="items.value" :duration="1000" />
                                      </span>
                                      <span class="font-size-12 ct-text-muted">{{ i === 0 ? '명' : '원' }}</span>
                                    </div>
                                  </div>

                                  <div v-else class="pt-2 mt-1">
                                    <div v-for="(ele, idx) in items.value" class="row py-1" :id="`top3-tooltip-${ele.rowNum}`">
                                      <div class="col-auto p-0">
                                        <b-badge class="badge badge-soft-deep-green rounded-pill p-1 me-3">
                                          {{ idx+1 }}
                                        </b-badge>
                                      </div>

                                      <span class="col-auto p-0 text-center" style="cursor:pointer;">
                                        {{ $_utils.textLengthOverCut(ele.userId, 5, '') }}
                                      </span>
                                      <span class="col-auto p-0 text-bold mx-3">
                                        |
                                      </span>
                                      <span class="col p-0" id="place-name-tooltip" style="cursor:pointer;">
                                        {{ $_utils.textLengthOverCut(ele.placeName, 20, '')}}
                                      </span>

                                      <b-tooltip :target="`top3-tooltip-${ele.rowNum}`" placement="topright">
                                        <span>
                                          {{ ele.userId }} {{ ele.placeName }} ({{ ele.chargeCount }}회)
                                        </span>
                                      </b-tooltip>
                                    </div>



                                  </div>

<!--                                  <div class="text-end">
                                    <div>
                                      <span class="fw-bold text-black" style="font-size: 22px">
                                        <countTo :startVal="0" :endVal="items.num1" :duration="1000" />
                                      </span>
                                      <span class="font-size-12 ct-text-muted">{{ i === 2 ? '회' : '명' }}</span>
                                    </div>

                                    <div>
                                      <span class="fw-bold text-danger" style="font-size: 22px">
                                        <countTo :startVal="0" :endVal="items.num2" :duration="1000" />
                                      </span>
                                      <span class="font-size-12 ct-text-muted">{{ i === 0 ? '건' : '원' }}</span>
                                    </div>

                                    <div>
                                      <span class="fw-bold text-primary" style="font-size: 22px">
                                        <countTo :startVal="0" :endVal="items.num3" :duration="1000" />
                                      </span>
                                      <span class="font-size-12 ct-text-muted">%</span>
                                    </div>
                                  </div>-->

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- // Broken Unused -->
                  <div class="row">
                    <div class="col">
                      <div class="card">
                        <div class="card-body pb-0">

                          <div class="row">
                            <div class="col-xl-6">
                              <div class="row relative">
                                <card-title icon-image="mdi-battery-off-outline"
                                            title="충전기 고장 현황" text-color="title" class="col-auto"/>
                                <div class="col text-end pe-3 text-secondary font-size-12 align-self-end">
                                  {{`(${$moment().subtract(1, 'days').format('YYYY-MM-DD')} 기준)`}}
                                </div>
                              </div>

                              <div class="row">
                                <div class="col">
                                  <div class="card px-2">
                                    <div class="row">
                                      <div class="col-10 offset-1">
                                        <apexchart height="150"
                                                   :options="brokenPercentChartOptions" :series="brokenPercentChartSeries" />
                                      </div>
                                      <div v-if="!$_utils.isEmpty(brokenData.chart)" class="col-1 ps-0 pt-1 text-end">
                                        <i v-if="brokenData.chart[1].count !== 0" class="mdi mdi-dots-vertical font-size-24" style="cursor: pointer"
                                           @click="chargerDetail('broken')" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-xl-6">
                              <card-title icon-image="mdi-battery-alert-variant-outline"
                                          title="장기 미사용 충전기 현황" text-color="title" class="relative" />
                              <div class="row">
                                <div class="col">
                                  <div class="card px-2">
                                    <div class="row">
                                      <div class="col-10 offset-1">
                                        <apexchart height="150"
                                                   :options="unusedPercentChartOptions" :series="unusedPercentChartSeries" />
                                      </div>
                                      <div v-if="!$_utils.isEmpty(unusedData.chart)" class="col-1 ps-0 pt-1 text-end">
                                        <i v-if="unusedData.chart.unusedCount !== 0" class="mdi mdi-dots-vertical font-size-24" style="cursor: pointer"
                                           @click="chargerDetail('unused')" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Middle Right Area -->

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Middle Area -->

      <!-- START Bottom Area -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card shadow mb-0">
            <div class="card-body pb-0">
              <div class="row">

                <!-- Start Bottom Left Area -->
                <div class="col-xl-6">
                  <div class="card">
                    <div class="card-body">
                      <card-title icon-image="mdi-chart-line" title="금일 충전 패턴" text-color="title"/>
                      <div>
                        <div class="fw-bold">충전 금액 (원)</div>
                        <apexchart height="180"
                                   :options="todayPatternCostChartOptions" :series="todayPatternCostChartSeries" />
                      </div>
                      <div>
                        <div class="fw-bold">이용 건수 (건)</div>
                        <apexchart height="180"
                                   :options="todayPatternCountChartOptions" :series="todayPatternCountChartSeries" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Bottom Left Area -->

                <!-- Start Bottom Right Area -->
                <div class="col-xl-6">
                  <div class="card card-height-100">
                    <div class="card-body">
                      <div class="row mb-2">
                        <div class="col-lg-6">
                          <card-title icon-image="mdi-table-large" title="금일 충전 이력" text-color="title"/>
                        </div>

                        <div class="col-lg-4 offset-lg-2 pt-3 pe-3">
                          <div class="text-end align-items-end">
                            <span class="text-secondary">충전중 | </span>
                            <span class="fw-bold">{{ charge.ing.toLocaleString() }}</span>
                            <span class="text-secondary ms-1">건</span>
                            <span class="text-secondary ms-3">충전완료 | </span>
                            <span class="fw-bold">{{ charge.complete.toLocaleString() }}</span>
                            <span class="text-secondary ms-1">건</span>
                          </div>
                        </div>
                      </div>

                      <div class="evse-use-table">
                        <b-table class="datatables text-nowrap"
                                 :fields="chargeFields" :items="chargeItems">
                          <template #cell(placeName)="data">
                            <span :title="`${data.item.placeName}`">{{ $_utils.textLengthOverCut(data.item.placeName, 15, '') }}</span>
                          </template>
                          <template #cell(userId)="data">
                            <span :title="`${data.item.userId}`">{{ $_utils.textLengthOverCut(data.item.userId, 7, '') }}</span>
                          </template>
                          <template #cell(startTime)="data">
                            {{ $_utils.changeDateFormat(data.item.startTime, 'MM-DD HH:mm:ss') }}
                          </template>
                          <template #cell(status)="data">
                        <span :style="`color: ${data.item.statusColor === 'orange' ? '#ff8902' : '#0576b9'}`">
                          {{ data.item.statusColor === 'orange' ? '충전중' : '충전완료' }}
                        </span>
                          </template>
                        </b-table>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- END Bottom Right Area -->

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Bottom Area -->

      <use-detail-modal ref="useDetailModal" :modal-type="modalType" />
      <broken-unused-modal ref="brokenUnusedModal"
                           :charger-info-type="chargerInfoType"
                           :broken-data="brokenData"
                           :unused-data="unusedData" />
<!--      <error-detail-modal ref="errorDetailModal" />-->

    </section>
  </Layout>
</template>

<script>
import { http } from '@/mdk/auth-api';
import Layout from '@/views/layouts/main.vue'
import Multiselect from 'vue-multiselect';
import infoCountTo from '@/views/pages/dashboard/indexInfoCountTo.vue';
import cardTitle from '@/views/components/cardTitle.vue';
import useDetailModal from '@/views/pages/dashboard/useModal.vue';
import errorDetailModal from '@/views/pages/dashboard/errorModal.vue';
import CountTo from "vue-count-to";
import BrokenUnusedModal from '@/views/pages/dashboard/brokenUnusedModal.vue';

export default {
  components: { BrokenUnusedModal, CountTo, Layout, Multiselect, infoCountTo, cardTitle, useDetailModal, errorDetailModal },
  data() {
    return {
      modalType: null,
      chargerInfoType: null,
      nowDate: null,
      nowTime: null,
      searchForm: {
        busiId: { value: 'KL', text: '클린일렉스' },
        chargingPattern: { value: 'all', text: '전체' }
      },
      businessOptions: [
        { value: 'KL', text: '클린일렉스' }
      ],
      stationChartItems: null,
      stationChartOptions: {
        chart: {
          stacked: true,
          sparkline: { enabled: true },
          offsetY: 8,
          fontFamily: 'NanumSquareRound',
        },
        colors: ['#004D26'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '25%',
            colors: { backgroundBarColors: ['#f4f4f2'] }
          }
        },
        title: {
          floating: true,
          offsetX: -5,
          offsetY: 10,
          text: '이용 0 개',
          style: { color: '#000000' }
        },
        subtitle: {
          floating: true,
          align: 'right',
          offsetX: 5,
          offsetY: 10,
          text: '미이용 0 개',
          style: { color: '#9599ad', fontSize: '14px' }
        },
        tooltip: {
          enabled: false
        },
        yaxis: {
          max: 100
        },
        series: [
          {
            name: '이용률',
            data: [0]
          }
        ]
      },
      chargeItems: [],
      statusColor: {
        Available: '#0576b9',
        Faulted: '#495057',
        Occupied: '#ff8902',
        Unavailable: '#adb5bd'
      },
      statusChartSeries: [],
      statusChartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '75%',
            hideZeroBarsWhenGrouped: false
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: ['완속 충전기', '급속 충전기'],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()} 기`,
            title: {
              formatter: seriesName => '',
            },
          }
        },
        grid: {
          show: false,
          padding: {
            top: -35,
            right: 0,
            bottom: -15,
            left: 0
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          offsetY: -3,
          markers: {
            offsetY: 2
          }
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -10,
          style: {
            color: '#858585',
          }
        }
      },
      recommendService: [
        { title: '추천 서비스 이용자' },
        { title: '충전 요금절감 합계' },
        { title: '충전소 이용 상위' }
      ],
      stationUseItems: {
        userCount: 0,
        compUserCount: 0,
        chargedCount: 0,
        compChargedCount: 0,
        totEnergy: 0,
        compTotEnergy: 0,
        totCost: 0,
        compTotCost: 0
      },
      evseErrorItems: [],
      chargingPatternItems: [],
      charge: {
        ing: 0,
        complete: 0
      },
      chargeFields: [
        { key: 'placeName', label: '충전소', sortable: true },
        { key: 'csoEvseNum', label: '충전기', sortable: true },
        { key: 'userId', label: '이용자', sortable: true },
        { key: 'startTime', label: '충전시작', sortable: true },
        { key: 'elapseTime', label: '경과시간', sortable: true },
        { key: 'status', label: '상태', sortable: true }
      ],
      summaryCount: {
        placeCount: 0,
        fastCount: 0,
        slowCount: 0
      },
      evseStatus: [],
      brokenData: {},
      brokenPercentChartSeries: [],
      brokenPercentChartOptions: {
        chart: {
          type: 'donut',
          toolbar: { show: false },
          selection: { enabled: false },
          fontFamily: 'NanumSquareRound',
        },
        legend: { show: false },
        colors: ['#f5554a', '#e5e3e3'],
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0],
          formatter: (value, { seriesIndex, dataPointIndex, w }) => {
            const total = w.config.series.reduce((a, b) => a + b)
            return seriesIndex === 0 ? `${Math.round((w.config.series[0] / total) * 100)}%` : ''
          },
          textAnchor: 'middle',
          style: {
            fontSize: '12px',
            fontWeight: 400,
            colors: ['#ffffff'],
          },
          background: {
            enabled: true,
            padding: 5,
            foreColor: '#f5554a',
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#f5554a',
            opacity: 0.9,
          },
          dropShadow: {
            enabled: false,
          }
        },
        subtitle: {
          align: 'center',
          offsetY: 95,
          floating: true,
          style: {
            color:  '#858585',
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            dataLabels: {
              minAngleToShowLabel: 5
            },
            donut: {
              size: '75%',
              labels: {
                show: true,
                name: {
                  show: true,
                  offsetY: -25,
                },
                value: {
                  show: true,
                  fontSize: '24px',
                  fontWeight: 400,
                  offsetY: -8,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '고장',
                  fontSize: '13px',
                  fontWeight: 600,
                  color: '#f5554a',
                  formatter: w => `${w.globals.seriesTotals[0].toLocaleString()}기`
                }
              }
            }
          }
        },
        labels: ['고장', '정상'],
        stroke: {
          show: false,
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          theme: 'light',
          y: {
            formatter: val => `${val.toLocaleString()}기`,
          },
        },
        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -20,
          style: {
            color: '#858585',
          }
        }
      },
      unusedData: {},
      unusedPercentChartSeries: [],
      unusedPercentChartOptions: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
          selection: {
            enabled: false,
          },
          fontFamily: 'NanumSquareRound',
        },
        legend: { show: false },
        colors: ['#bde513', '#e5e3e3'],
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0],
          formatter: (value, { seriesIndex, dataPointIndex, w }) => {
            const total = w.config.series.reduce((a, b) => a + b)
            return seriesIndex === 0 ? `${Math.round((w.config.series[0] / total) * 100)}%` : ''
          },
          textAnchor: 'middle',
          style: {
            fontSize: '12px',
            fontWeight: 400,
            colors: ['#ffffff'],
          },
          background: {
            enabled: true,
            padding: 5,
            foreColor: '#78a600',
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#78a600',
            opacity: 0.9,
          },
          dropShadow: {
            enabled: false,
          }
        },
        subtitle: {
          align: 'center',
          offsetY: 95,
          floating: true,
          style: {
            color:  '#858585',
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            dataLabels: {
              minAngleToShowLabel: 5
            },
            donut: {
              size: '75%',
              labels: {
                show: true,
                name: {
                  show: true,
                  offsetY: -25,
                },
                value: {
                  show: true,
                  fontSize: '24px',
                  fontWeight: 400,
                  offsetY: -8,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '미사용',
                  fontSize: '13px',
                  fontWeight: 600,
                  color: '#78a600',
                  formatter: w => `${w.globals.seriesTotals[0].toLocaleString()}기`
                }
              }
            }
          }
        },
        labels: ['미사용', '사용'],
        stroke: {
          show: false,
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          theme: 'light',
          y: {
            formatter: val => `${val.toLocaleString()}기`,
          },
        },
        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -20,
          style: {
            color: '#858585',
          }
        }
      },
      todayPatternCostChartSeries: [
        { name: '완속', data: [], },
        { name: '급속', data: [], }
      ],
      todayPatternCostChartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
          animations: {
            enabled: true,
            speed: 500,
          }
        },
        colors: ['#e7f3eb', '#006633FF'],
        fill: {
          opacity: 1
        },
        stroke: {
          show: true,
          colors: ['#006633FF'],
          width: 2,
          dashArray: 0,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '75%',
            rangeBarGroupRows: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: Array.from({ length: 24 }, (v, i) => i),
          tickPlacement: 'between',
        },
        yaxis: {
          tickAmount: 2,
          max: max => {
            if (max > 500) {
              return Math.ceil(max / 500) * 500;
            }
            else {
              return Math.ceil(max / 10) * 10;
            };
          },
          labels: {
            minWidth: 60,
            maxWidth: 60,
            offsetX: -10,
            formatter: val => val.toLocaleString(),
          }
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()} 원`,
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          markers: {
            strokeWidth: [1, 0],
            strokeColor: '#006633FF',
            offsetY: 2
          }
        },
        grid: {
          show: false,
          padding: {
            top: -20,
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -30,
          style: {
            color: '#858585',
          }
        }
      },
      todayPatternCountChartSeries: [
        { name: '완속', data: [] },
        { name: '급속', data: [] }
      ],
      todayPatternCountChartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: false },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0,
          animations: {
            enabled: true,
            speed: 500,
          }
        },
        colors: ['#e7f3eb', '#006633FF'],
        fill: {
          opacity: 1
        },
        stroke: {
          show: true,
          colors: ['#006633FF'],
          width: 2,
          dashArray: 0,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '75%',
            rangeBarGroupRows: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: Array.from({ length: 24 }, (v, i) => i),
          tickPlacement: 'between',
        },
        yaxis: {
          tickAmount: 2,
          max: max => {
            if (max > 500) {
              return Math.ceil(max / 500) * 500;
            }
            else {
              return Math.ceil(max / 10) * 10;
            };
          },
          labels: {
            minWidth: 60,
            maxWidth: 60,
            offsetX: -10,
            formatter: val => val.toLocaleString(),
          }
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()} 건`,
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          markers: {
            strokeWidth: [1, 0],
            strokeColor: '#006633FF',
            offsetY: 2
          }
        },
        grid: {
          show: false,
          padding: {
            top: -20,
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -30,
          style: {
            color: '#858585',
          }
        }
      },
    }
  },
  created() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems() {
      const vm = this;
      vm.nowDate = this.$_utils.nowDate() + ' (' + this.$_utils.nowDay() + ')';
      vm.nowTime = this.$_utils.nowTime();

      // 충전소 & 충전기 & 맞춤형 충전서비스 & 금일 충전 이력 정보
      vm.getStationItems();
      // 충전 이용 현황 정보
      vm.getStationUseItems();
      // 충전기 고장미사용 정보
      vm.getBrokenUnUsedItems();
      // 금일 충전 패턴
      vm.getChargingPatternItems();

    },
    getStationItems() {
      const vm = this;
      const _url = '/onmapi/dashboard/info';
      http.get(_url)
        .then(res => {
          vm.summaryCount = res.data.placeEvseCountBySlowFast[0];

          /*vm.recommendService[0] = { ...vm.recommendService[0], ...res.data.recommendSaveCostDr.recommend }
          vm.recommendService[1] = { ...vm.recommendService[1], ...res.data.recommendSaveCostDr.saveCost }
          vm.recommendService[2] = { ...vm.recommendService[2], ...res.data.recommendSaveCostDr.drService }*/

          vm.recommendService[0] = { ...vm.recommendService[0], ...{ value: res.data.recommendSaveCostDr.recommendUserCount } }
          vm.recommendService[1] = { ...vm.recommendService[1], ...{ value: res.data.recommendSaveCostDr.sumSavedCost } }
          vm.recommendService[2] = { ...vm.recommendService[2], ...{ value: res.data.recommendSaveCostDr.rankUserTop3 } }

          vm.chargeItems = res.data.todayTransactionHist;
          vm.chargeItems.map(item => {
            if (item.status === '충전중') vm.charge.ing++;
            else if (item.status === '완료') vm.charge.complete++;
          });

          vm.evseStatus = res.data.realTimeEvseStatus;
          vm.drawStatusChart();
        })
        .catch(err => {
          console.error('Dashboard Info Data Error :: ', err)
        });
    },
    drawStatusChart() {
      const vm = this;

      const statusList = vm.evseStatus.slow.map(ele => ele.connectorStatus)
      vm.statusChartSeries = vm.evseStatus.slow.map((slowEle, i)=> (
        {
          name: statusList[i],
          data: [slowEle.cnt, vm.evseStatus.fast[i].cnt]
        }
      ));

      vm.statusChartOptions = {
        ...vm.statusChartOptions,
        ...{ colors: statusList.map(ele => vm.statusColor[ele]) }
      };
    },
    getStationUseItems() {
      const vm = this;
      const _url = '/onmapi/dashboard/tran-count';

      http.get(_url)
        .then((res) => {
          vm.stationUseItems = Object.assign({}, res.data.tranCount);
        }).catch(err => {
          console.error('Station Use Info Data Error :: ', err)
        });
    },
    getBrokenUnUsedItems() {
      const vm = this;
      const brokenUrl = '/onmapi/evse/faultData';

      http.get(brokenUrl, {
        params: {
          placeId: 'all',
          // startDate: moment().subtract(1, 'days').subtract(1, 'month').format('YYYY-MM-DD'),
          startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          endDate: moment().subtract(1, 'days').format('YYYY-MM-DD')
        }
      }).then((res) => {
        vm.brokenData = res.data;
        vm.updateBrokenPercentChart();
      }).catch(err => {
          console.error(err)
        });

      const unusedUrl = `/onmapi/evse/longTimeUnused`;
      http.get(unusedUrl, {
        params: {
          placeId: 'all'
        }
      }).then((res) => {
        vm.unusedData = res.data;
        vm.updateUnusedPercentChart();
      }).catch(err => {
          console.error(err)
        });
    },
    updateBrokenPercentChart() {
      const vm = this;
      vm.brokenPercentChartSeries = [ vm.brokenData.chart[1].count, vm.brokenData.chart[2].count ];
      vm.brokenPercentChartOptions = {
        ...vm.brokenPercentChartOptions,
        ...{
          subtitle: {
            text: `전체 ${vm.brokenData.chart[0].count.toLocaleString()} 기`,
          }
        }
      };
    },
    updateUnusedPercentChart() {
      const vm = this;

      vm.unusedPercentChartSeries = [ vm.unusedData.chart.unusedCount, vm.unusedData.chart.usedCount ];
      vm.unusedPercentChartOptions = {
        ...vm.unusedPercentChartOptions,
        ...{
          subtitle: {
            text: `전체 ${vm.unusedData.chart.totalCount.toLocaleString()} 기`,
          }
        }
      };
    },
    getChargingPatternItems() {
      const vm = this;
      const _url = `/onmapi/dashboard/pattern`;

      http.get(_url)
        .then((res) => {
          vm.chargingPatternItems = res.data.chartData;
          if (vm.chargingPatternItems.length > 0) {
            vm.drawPatternCharts();
          }
        })
        .catch(err => {
          console.error('Charging Pattern Chart Data Error :: ', err)
        });
    },
    drawPatternCharts() {
      const vm = this;

      const acCostData = [];
      const dcCostData = [];
      const acCountData = [];
      const dcCountData = [];

      vm.chargingPatternItems.forEach(ele => {
        acCostData.push(ele.slowCost);
        dcCostData.push(ele.fastCost);
        acCountData.push(ele.slowCount);
        dcCountData.push(ele.fastCount)
      });

      vm.todayPatternCostChartSeries = [
        { name: '완속', data: acCostData, },
        { name: '급속', data: dcCostData, }
      ];

      vm.todayPatternCountChartSeries = [
        { name: '완속', data: acCountData, },
        { name: '급속', data: dcCountData, }
      ];
    },
    useDetail(type) {
      const vm = this;
      vm.modalType = type;
      this.$refs.useDetailModal.show();
    },
    chargerDetail(type) {
      const vm = this;
      vm.chargerInfoType = type;
      this.$refs.brokenUnusedModal.show();
    },
  }
}
</script>
